import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { LinkShortenerComponent } from './link-shortener.component';
import { LinksSubconfigComponent } from './links-subconfig/links-subconfig.component';
import { TransformationEditionComponent } from './links-subconfig/transformation-edition/transformation-edition.component';

@NgModule({
  declarations: [LinkShortenerComponent, LinksSubconfigComponent, TransformationEditionComponent],
  imports: [CommonModule, SharedModule],
})
export class LinkShortenerModule {}
